'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _underscore = require('underscore');
var _underscore2 = _interopRequireDefault(_underscore);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactFontawesome = require('@fortawesome/react-fontawesome');
var _freeSolidSvgIcons = require('@fortawesome/free-solid-svg-icons');
var _DropDownListPanel = require('./DropDownListPanel');
var _DropDownListPanel2 = _interopRequireDefault(_DropDownListPanel);
var _Chip = require('../Chip');
var _utilities = require('../../utilities');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * A component that allows a user to select from a list of items. The list is shown
 * in an overlay. The overlay is shown when the component is clicked. The component
 * has the ability to show a search box and a button 'add new'.
 */
var DropDownBase = function (_React$Component) {
  _inherits(DropDownBase, _React$Component);
  function DropDownBase(props) {
    _classCallCheck(this, DropDownBase);

    // the selectedValue prop could be a string or a number or an array (if this is a multi-select dropdown)
    // internally we will always use the selectedValue as an array.
    // When communicating the selected value back to the consumer we will send it as an array if the dropdown
    // is multiselect or as a singluar value (string or number) if it is not a multiselect dropdown.
    var _this = _possibleConstructorReturn(this, (DropDownBase.__proto__ || Object.getPrototypeOf(DropDownBase)).call(this, props));
    var _selectedValue = _this.convertSelectedValueForInternal(_this.props.selectedValue);
    _this.state = {
      isFocused: false,
      isListShown: false,
      selectedValue: _selectedValue,
      data: _this.props.data
    };
    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleAddNewButtonClick = _this.handleAddNewButtonClick.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleSelectionConfirmation = _this.handleSelectionConfirmation.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    _this.getDropDownList = _this.getDropDownList.bind(_this);
    _this.getValidationMessage = _this.getValidationMessage.bind(_this);
    _this.getSelectedValueForEvent = _this.getSelectedValueForEvent.bind(_this);
    return _this;
  }

  /**
   * the selectedValue prop could be a string or a number or an array (if this is a multi-select dropdown)
   * internally we will always use the selectedValue as an array.
   * When communicating the selected value back to the consumer we will send it as an array if the dropdown
   * is multiselect or as a singluar value (string or number) if it is not a multiselect dropdown.
   */

  _createClass(DropDownBase, [{
    key: 'convertSelectedValueForInternal',
    value: function () {
      function convertSelectedValueForInternal(selectedValue) {
        var _selectedValue = [];
        if (Array.isArray(selectedValue) === true) {
          _selectedValue = selectedValue;
        } else if (selectedValue && selectedValue.length > 0) {
          _selectedValue.push(selectedValue);
        } else if (typeof selectedValue === 'number') {
          _selectedValue.push(selectedValue);
        }
        return _selectedValue;
      }
      return convertSelectedValueForInternal;
    }()

    /**
     * Handler for the keydown event. This function handles the esc key press, to close
     * the dropdown if it is expanded.
     * @param {*} e keydown event object
     */
  }, {
    key: 'handleKeyDown',
    value: function () {
      function handleKeyDown(e) {
        var ESC_KEY_CODE = 27;
        if (this.props.multiselect !== true && e.keyCode == ESC_KEY_CODE) {
          if (this.state.isListShown === true) {
            this.setState({
              isListShown: false
            });
          }
        }
      }
      return handleKeyDown;
    }()
  }, {
    key: 'handleFocus',
    value: function () {
      function handleFocus() {
        this.setState({
          isFocused: true
        });
      }
      return handleFocus;
    }()
  }, {
    key: 'handleBlur',
    value: function () {
      function handleBlur() {
        this.setState({
          isFocused: false
          /*,
                 * Noble idea of hiding the list when the drop down loses focus but
                 * implementation is tricky because it interferes with the keyboard
                 * navigation.
                isListShown: false
                */
        });
        // call the validator only when the list is not visible, when it is still visible
        // the user is still interacting with the control
        if (typeof this.props.validator === 'function' && this.state.isListShown === false && this.props.disabled !== true) {
          var validator = this.props.validator.bind(null, this.getSelectedValueForEvent());
          validator();
        }
      }
      return handleBlur;
    }()

    /**
     * Handler for the click event on the dropdown. If the dropdown is expanded, it is collapsed and if it is collapsed, then it is expanded.
     * @param {*} e click event object
     */
  }, {
    key: 'handleClick',
    value: function () {
      function handleClick(e) {
        e.stopPropagation();
        e.nativeEvent && e.nativeEvent.stopImmediatePropagation && e.nativeEvent.stopImmediatePropagation();
        if (this.props.disabled === true) {
          e.preventDefault();
        } else {
          this.setState({
            isListShown: !this.state.isListShown
          });
        }
      }
      return handleClick;
    }()

    /**
     * Function that handles the click on the document. Used for collapsing the dropdown if it is expanded.
     * @param {*} e click event object
     */
  }, {
    key: 'handleDocumentClick',
    value: function () {
      function handleDocumentClick(e) {
        if (this.state.isListShown === true && this.listPanelContainerRef && this.listPanelContainerRef.contains(e.target) === false) {
          this.setState({
            isListShown: false
          });
        }
      }
      return handleDocumentClick;
    }()
  }, {
    key: 'handleChange',
    value: function () {
      function handleChange(selectedValue) {
        this.setState({
          selectedValue: selectedValue
        });
      }
      return handleChange;
    }()

    /**
     * Returns the selected value to return to the consumer of the component. If the dropdown is multiselect
     * then return the array else return a single value.
     */
  }, {
    key: 'getSelectedValueForEvent',
    value: function () {
      function getSelectedValueForEvent() {
        var _selectedValue = this.state.selectedValue;
        if (this.props.multiselect !== true) {
          // separate out the first item in the array (there should only be one item in there) and return it
          if (this.state.selectedValue.length > 0) {
            _selectedValue = this.state.selectedValue[0];
          } else {
            _selectedValue = null;
          }
        }
        return _selectedValue;
      }
      return getSelectedValueForEvent;
    }()
  }, {
    key: 'handleSelectionConfirmation',
    value: function () {
      function handleSelectionConfirmation(selectedValue, e, nativeEvent) {
        var _this2 = this;
        this.setState({
          selectedValue: selectedValue,
          isListShown: this.props.multiselect !== true ? false : this.state.isListShown
        }, function () {
          // emit the change event for the dropdown
          (0, _utilities.dispatchEvent)('xactly.components.dropdown.change', {
            originalEvent: nativeEvent,
            selectedValue: selectedValue
          });
          if (typeof _this2.props.changeHandler === 'function') {
            _this2.props.changeHandler(_this2.getSelectedValueForEvent(), e, nativeEvent);
          }
        });
      }
      return handleSelectionConfirmation;
    }()
  }, {
    key: 'handleAddNewButtonClick',
    value: function () {
      function handleAddNewButtonClick(e) {
        var _this3 = this;
        this.setState({
          isListShown: false
        }, function () {
          if (typeof _this3.props.addNewButtonClickHandler === 'function') {
            _this3.props.addNewButtonClickHandler(e);
          }
        });
      }
      return handleAddNewButtonClick;
    }()
  }, {
    key: 'getDropDownList',
    value: function () {
      function getDropDownList() {
        var _this4 = this;
        if (this.state.isListShown === true) {
          if (Array.isArray(this.state.data) === true) {
            var labels = {};
            if ((0, _utilities.labelExists)(this.props.labels, 'addNewButtonText')) {
              labels.addNewButtonText = (0, _utilities.getLabel)(this.props.labels, 'addNewButtonText');
            }
            if ((0, _utilities.labelExists)(this.props.labels, 'selectAllText')) {
              labels.selectAllText = (0, _utilities.getLabel)(this.props.labels, 'selectAllText');
            }
            if ((0, _utilities.labelExists)(this.props.labels, 'selectResultsText')) {
              labels.selectResultsText = (0, _utilities.getLabel)(this.props.labels, 'selectResultsText');
            }
            return _react2['default'].createElement(_DropDownListPanel2['default'], {
              id: 'dropDownListPanel',
              tabIndex: 11,
              data: this.state.data,
              textPropName: this.props.textPropName,
              valuePropName: this.props.valuePropName,
              disabledPropName: this.props.disabledPropName,
              selectedValue: this.state.selectedValue,
              multiselect: this.props.multiselect,
              changeHandler: this.handleChange,
              labels: labels,
              addNewButtonClickHandler: this.handleAddNewButtonClick,
              selectionConfirmedHandler: this.handleSelectionConfirmation,
              searchBox: this.props.searchBox,
              size: this.props.size,
              theme: this.props.theme,
              selectAllChangeHandler: this.props.selectAllChangeHandler,
              setRef: function () {
                function setRef(listPanelContainerRef) {
                  _this4.listPanelContainerRef = listPanelContainerRef;
                }
                return setRef;
              }()
            });
          } else {
            return null;
          }
        } else {
          return null;
        }
      }
      return getDropDownList;
    }()
  }, {
    key: 'getValidationMessage',
    value: function () {
      function getValidationMessage() {
        if (this.props.validationMessage != null && this.props.validationMessage != undefined && this.props.validationMessage.length > 0) {
          return _react2['default'].createElement('span', {
            id: 'validationMessage'
          }, this.props.validationMessage);
        } else {
          return null;
        }
      }
      return getValidationMessage;
    }()
  }, {
    key: 'getDropdownIcon',
    value: function () {
      function getDropdownIcon() {
        var _props = this.props,
          iconArrowDown = _props.iconArrowDown,
          iconArrowUp = _props.iconArrowUp,
          toggleArrow = _props.toggleArrow;
        var isListShown = this.state.isListShown;
        return !toggleArrow ? iconArrowDown : isListShown ? iconArrowUp : iconArrowDown;
      }
      return getDropdownIcon;
    }()
  }, {
    key: 'renderSelectedItems',
    value: function () {
      function renderSelectedItems() {
        var _this5 = this;
        if (this.props.multiselect !== true) {
          // get the single value from the selectedValue array
          var _selectedValue = this.getSelectedValueForEvent();
          if (_selectedValue != null) {
            // search in the props.data instead of the state because
            // when searching, the state.data will get updated and we will
            // not find the current selected item in there.
            var selectedItem = _underscore2['default'].find(this.props.data, function (item) {
              return item[_this5.props.valuePropName] === _selectedValue;
            });
            return selectedItem[this.props.textPropName];
          } else {
            // no selected value, return caption or empty string
            return (0, _utilities.getLabel)(this.props.labels, 'caption', this.props.caption);
          }
        } else {
          if (Array.isArray(this.state.selectedValue) && this.state.selectedValue.length > 0) {
            var self = this;
            return this.state.selectedValue.map(function (value, index) {
              var selectedItem = _underscore2['default'].find(self.props.data, function (item) {
                return item[self.props.valuePropName] === value;
              });
              return _react2['default'].createElement(_Chip.Chip, {
                key: 'chip_' + index,
                selectedItem: selectedItem,
                itemDisplayPropName: self.props.textPropName,
                removeItemEventHandler: self.props.removeItemHandler,
                theme: self.props.theme
              });
            });
          } else {
            // no selected value, return caption, else null
            return this.props.caption || '';
          }
        }
      }
      return renderSelectedItems;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(nextProps) {
        var _this6 = this;
        var _newSelectedValue = void 0;
        if (!_underscore2['default'].isEqual(this.props.selectedValue, nextProps.selectedValue) || !_underscore2['default'].isEqual(this.getSelectedValueForEvent(), nextProps.selectedValue)) {
          _newSelectedValue = this.convertSelectedValueForInternal(nextProps.selectedValue);
        } else {
          var selectedItem = this.state.selectedValue;
          if (this.props.multiselect !== true) {
            selectedItem = _underscore2['default'].find(nextProps.data, function (item) {
              return item[nextProps.valuePropName] === _this6.getSelectedValueForEvent();
            });
          }
          _newSelectedValue = selectedItem ? this.state.selectedValue : this.convertSelectedValueForInternal(undefined);
        }
        if (_underscore2['default'].isEqual(this.state.data, nextProps.data) === false || _underscore2['default'].isEqual(this.state.selectedValue, _newSelectedValue) === false) {
          this.setState({
            data: nextProps.data,
            selectedValue: _newSelectedValue
          });
        }
      }
      return componentWillReceiveProps;
    }()
  }, {
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        document.addEventListener('click', this.handleDocumentClick);
        document.addEventListener('keydown', this.handleKeyDown);
      }
      return componentDidMount;
    }()

    /**
     * The selected item container can expand when the number of items added exceeds the starting height. We need the list panel container shift down by that increase in height.
     * So we get the client height of the container and shift the top of the list panel by that client height. We call a method on the ListPanel that updates the top using the reference to the ListPanel.
     */
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate() {
        var minHeight = 28;
        var clientHeight = this.selectedItemContainerRef.clientHeight;
        if (clientHeight > minHeight) {
          this.listPanelContainerRef && (this.listPanelContainerRef.style.top = clientHeight + 2 + 'px');
        } else {
          this.listPanelContainerRef && (this.listPanelContainerRef.style.top = minHeight + 'px');
        }
      }
      return componentDidUpdate;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        document.removeEventListener('click', this.handleDocumentClick);
        document.removeEventListener('keydown', this.handleKeyDown);
      }
      return componentWillUnmount;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this7 = this;
        var id = this.props.id || _underscore2['default'].uniqueId('dropDown_');

        // add border radius change based on isListShown
        var mainContainerStyle = {
          borderBottomLeftRadius: 2,
          borderBottomRightRadius: 2,
          boxShadow: 'none'
        };
        if (this.state.isListShown === true) {
          mainContainerStyle = {
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
          };
        }
        if (this.state.isFocused === true && this.props.disabled === false && this.state.isListShown === false) {
          mainContainerStyle.boxShadow = '0 0 4px #64ADC2';
        }
        // If tabIndex is null or undefined then setting its value to a very large number
        // so that it does not interfere with the normal tabbing. If tabindex is not set
        // the div will not get the focus and the focus event will not trigger and we wont
        // see the beautiful halo around the component when it is in focus.
        var tabIndex = 1000;
        if (this.props.tabIndex > -1) {
          tabIndex = this.props.tabIndex;
        }
        var selectedItemContainerCaptionStyle = {
          color: '#666666',
          fontStyle: 'italic'
        };
        if (this.state.selectedValue.length > 0) {
          selectedItemContainerCaptionStyle = {};
        }
        // // highlight of selected text only works if the dropdown is not multiselect.
        // if (this.props.multiselect !== true) {
        //     // get the single value from the selectedValue array
        //     let _selectedValue = this.getSelectedValueForEvent();
        //     if (_selectedValue != null) {
        //         // search in the props.data instead of the state because
        //         // when searching, the state.data will get updated and we will
        //         // not find the current selected item in there.
        //         let selectedItem = _.find(this.props.data, (item) => {
        //             return item[this.props.valuePropName] === _selectedValue;
        //         });
        //         selectedText = selectedItem[this.props.textPropName];
        //         selectedItemContainerCaptionStyle = {};
        //     }
        // }

        return _react2['default'].createElement('div', {
          id: id,
          className: this.props.className
        }, _react2['default'].createElement('div', {
          id: 'mainContainer',
          style: mainContainerStyle,
          tabIndex: tabIndex,
          onClick: this.handleClick,
          onBlur: this.handleBlur,
          onFocus: this.handleFocus
        }, _react2['default'].createElement('div', {
          id: 'selectedItemContainer',
          style: selectedItemContainerCaptionStyle,
          ref: function () {
            function ref(selectedItemContainer) {
              _this7.selectedItemContainerRef = selectedItemContainer;
            }
            return ref;
          }()
        }, this.renderSelectedItems()), _react2['default'].createElement('div', {
          id: 'caretContainer'
        }, this.getDropdownIcon())), this.getDropDownList(), this.getValidationMessage());
      }
      return render;
    }()
  }]);
  return DropDownBase;
}(_react2['default'].Component);
DropDownBase.defaultProps = {
  iconArrowDown: _react2['default'].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faChevronDown
  }),
  iconArrowUp: _react2['default'].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faChevronUp
  }),
  size: 'medium',
  toggleArrow: false
};
DropDownBase.displayName = 'DropDown';
DropDownBase.propTypes = {
  /**
   * Function bound to the click event of the add new button.
   */
  addNewButtonClickHandler: _propTypes2['default'].func,
  /**
   * The text for the 'add new' button. The text should be in the format 'Add New {{Object Name}}'.
   * If the value of this prop is set then this button is visible in the drop down list at the top
   * of the list. It cannot be selected but can be clicked. The associated 'addNewButtonClickHandler'
   * can be set to a function that is called when the button is clicked.
   */
  addNewButtonText: _propTypes2['default'].string,
  /**
   * The caption shows the default text on the drop down component when no item
   * from the list is selected.
   */
  caption: _propTypes2['default'].string,
  /**
   * Function bound to the change event raised by the component when a different
   * item from the list is selected. The parameter passed to the change handler
   * is an array of selected values. For a single select dropdown a single value is returned.
   */
  changeHandler: _propTypes2['default'].func,
  /**
   * An array of objects bound to the list of items in the dropdown.
   * Format:
   * [
   *      { name: 'Aston Martin', value: 1 },
   *      { name: 'Ferrari', value: 2 },
   *      { name: 'Jaguar', value: 3 },
   *      { name: 'Land Rover', value: 4 }
   * ]
   * The textPropName in this case would be 'name'.
   * The valuePropName would be 'value'.
   */
  data: _propTypes2['default'].array,
  /**
   * When set to true disables the component, changes it look and the click handler
   * is disabled. Default is false.
   */
  disabled: _propTypes2['default'].bool,
  /**
   * Key name in the data array object to get the boolean value that determines if the list item is disabled or not.
   */
  disabledPropName: _propTypes2['default'].string,
  /**
   * A react element representing an icon for the dropdown arrow when the dropdown is closed. If the toggleArrow prop is not true, then this will remain the dropdown icon for all states.
   */
  iconArrowDown: _propTypes2['default'].element,
  /**
   * A react element representing an icon for the dropdown arrow when the dropdown is open. This icon is only used if the toggleArrow prop is set to true.
   */
  iconArrowUp: _propTypes2['default'].element,
  /**
   * The id for the component. If one is not provided a unique id is used.
   * Sets the id attribute on the element.
   */
  id: _propTypes2['default'].string,
  /**
   * Setting multiselect to true makes the DropDown a multi-select dropdown. It will add a checkbox in front of every option in the DropDown.
   */
  multiselect: _propTypes2['default'].bool,
  /**
   * The labels object contains the key value pairs for all the localizable strings.
   */
  labels: _propTypes2['default'].object,
  /**
   * When set to true shows an orange bar on the left side of the component.
   * Used to indicate that the component value needs to be set. Default is false.
   */
  required: _propTypes2['default'].bool,
  /**
   * Set this prop value to true if the search box should be enabled and shown.
   * Default is false.
   */
  searchBox: _propTypes2['default'].bool,
  /**
   * Pass a function to this prop to get notified when the 'Select All' checkbox is toggled.
   * The function is passed in an argument of type boolean indicating whether 'Select All' is checked or not.
   */
  selectAllChangeHandler: _propTypes2['default'].func,
  /**
   * The selected value can be set when the component is loaded.
   */
  selectedValue: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number, _propTypes2['default'].array]),
  /**
   * Size of the drop down component.
   * mini - use when the options in the drop down are 'if', 'and', 'or'
   * small - standard size of the drop down.
   * medium - use when the options in the drop down are 'equal to', 'not equal to' etc.
   * large - larger size of the drop down component.
   */
  size: _propTypes2['default'].oneOf(['xSmall', 'small', 'medium', 'large']),
  /**
   * The tab index property for the element, determines the tabbing position.
   * By default this property is not set.
   */
  tabIndex: _propTypes2['default'].number,
  /**
   * Key name in the data array object to get the text to display for the list item.
   */
  textPropName: _propTypes2['default'].string,
  /**
   * Used for internal default theme. Users of the dropdown should use the ThemeProvider from 'styled-components' to update the theme.
   *
   * @ignore
   */
  theme: _propTypes2['default'].object,
  /**
   * The caret/chevron on the right side of the drop down will remain pointing down when this is false. It points up when the dropdown is open if this is true.
   */
  toggleArrow: _propTypes2['default'].bool,
  /**
   * The validation message shown when validation fails.
   */
  validationMessage: _propTypes2['default'].string,
  /**
   * Function called when the component loses focus. The function is passed in the selected value argument.
   * It is also called when the triggerValidation prop value is set to true.
   */
  validator: _propTypes2['default'].func,
  /**
   * Key name in the data array object to get the value bound to the item in the list.
   */
  valuePropName: _propTypes2['default'].string
};
exports['default'] = DropDownBase;